import React from "react";
import AuthenticationModal, {
  LOGIN_MODE,
  FORGOT_PASSWORD_MODE,
  RESET_PASSWORD_MODE,
} from "src/core/authentication/components/AuthenticationModal";
import routes from "src/core/common/routes";
import CheckoutOnBoardingModal from "src/core/authentication/onboarding/CheckoutOnBoarding";
import Route from "src/core/common/components/modules/Route";
import ResetPasswordWithTokenModal from "src/core/authentication/components/ResetPasswordWithTokenModal";

function AuthenticationPage({onRequestClose}) {
  return (
    <>
      <Route
        path={routes.login}
        Component={AuthenticationModal}
        componentProps={{
          initialMode: LOGIN_MODE,
          onAuthenticationSuccessful: onRequestClose,
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.onBoarding}
        Component={CheckoutOnBoardingModal}
        componentProps={{
          closeModal: onRequestClose,
          options: {toCheckout: true, replaceOnClose: false},
        }}
      />
      <Route
        path={routes.signup}
        Component={CheckoutOnBoardingModal}
        componentProps={{
          closeModal: onRequestClose,
          options: {toCheckout: false, replaceOnClose: false},
        }}
      />
      <Route
        path={routes.forgotPassword}
        Component={AuthenticationModal}
        componentProps={{
          initialMode: FORGOT_PASSWORD_MODE,
          onAuthenticationSuccessful: onRequestClose,
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.resetPassword}
        Component={AuthenticationModal}
        componentProps={{
          initialMode: RESET_PASSWORD_MODE,
          onAuthenticationSuccessful: onRequestClose,
          closeModal: onRequestClose,
        }}
      />
      <Route
        path={routes.resetPasswordWithToken}
        Component={ResetPasswordWithTokenModal}
        componentProps={{
          closeModal: onRequestClose,
        }}
      />
    </>
  );
}

export default AuthenticationPage;
